import { render, staticRenderFns } from "./RoomTile.vue?vue&type=template&id=9137744e&"
import script from "./RoomTile.vue?vue&type=script&lang=js&"
export * from "./RoomTile.vue?vue&type=script&lang=js&"
import style0 from "./RoomTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src781945140/src/BedBoard.Sdk.Receiver/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9137744e', component.options)
    } else {
      api.reload('9137744e', component.options)
    }
    module.hot.accept("./RoomTile.vue?vue&type=template&id=9137744e&", function () {
      api.rerender('9137744e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RoomTile.vue"
export default component.exports